import React from "react";
import Heading from "@/components/elements/Heading";
import ProductItem from "@/components/layout/ProductItem";

/**
 * ProductList component that displays the shopping cart with all products
 * Shows the list of products and provides a button to create new products
 * 
 * @param {Object} props - Component props
 * @param {Array} props.products - Array of products in the shopping cart
 * @param {Function} props.onCreateNewProduct - Function to create new product
 * @param {Function} props.onDuplicateProduct - Function to duplicate product
 * @param {Function} props.onDeleteProduct - Function to delete product
 * @param {Function} props.onShowProductData - Function to show product details
 */
const ProductList = ({ 
    products, 
    onCreateNewProduct, 
    onDuplicateProduct, 
    onDeleteProduct, 
    onShowProductData 
}) => {
    return (
        <div
            className={`${products.length > 0 ? "col-lg-6" : "col-12"} shoppingpadding shoppingpaddingleft`}
        >
            <Heading heading="Winkelwagen">
                <a
                    name={"Nieuw product"}
                    href="#"
                    className="btn-orange"
                    onClick={onCreateNewProduct}
                >
                    Nieuw product
                </a>
            </Heading>

            <div className="shoppingproductlist">
                {products && products.length > 0 ? (
                    // Render product list
                    products.map((product, key) => (
                        <ProductItem
                            key={key}
                            product={product}
                            index={key}
                            onDuplicate={onDuplicateProduct}
                            onDelete={onDeleteProduct}
                            onShowProductData={onShowProductData}
                        />
                    ))
                ) : (
                    // Empty cart message
                    <p>Er zijn nog geen producten aangemaakt</p>
                )}
            </div>
        </div>
    );
};

export default ProductList; 